import { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import firebase from '../firebase';

export const AuthContext = createContext(null);
const auth = firebase.auth();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [running, setRunning] = useState(true);

  useEffect(() => {
    const unSubscribe = auth.onAuthStateChanged((currentUser) => {
      // Guests ko chupchaap anonymous token milta hai (Firestore rules
      // `auth != null` maangte hain) taaki customizer/catalog bina login
      // khule. Lekin app anonymous ko "logged-out" hi maanti hai — isliye
      // measurement / checkout / profile abhi bhi ASLI login maangte hain.
      setUser(currentUser && !currentUser.isAnonymous ? currentUser : null);
      setRunning(false);
    });
    return () => {
      unSubscribe();
    };
  }, []);

  const createNewUser = (email, password) => {
    setRunning(true);
    return auth.createUserWithEmailAndPassword(email, password)
      .finally(() => setRunning(false));
  };

  const UserLogin = (email, password) => {
    setRunning(true);
    return auth.signInWithEmailAndPassword(email, password)
      .finally(() => setRunning(false));
  };

  const userSignOut = () => {
    setRunning(true);
    return auth.signOut().finally(() => setRunning(false));
  };

  const loginWithGoogle = () => {
    const googleProvider = new firebase.auth.GoogleAuthProvider();
    setRunning(true);
    return auth.signInWithPopup(googleProvider)
      .finally(() => setRunning(false));
  };

  const contextData = {
    user,
    running,
    createNewUser,
    UserLogin,
    userSignOut,
    loginWithGoogle,
  };

  return (
    <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export default AuthProvider;
